import './visibility-toggles.styl'

function VisibilityToggles({ value = 'private', onChange }) {
  return (
    <div className="visibility-toggles">
      <button
        className={`visibility-toggles__button${value === 'private' ? ' visibility-toggles__button--active' : ''}`}
        onClick={() => onChange('private')}
        type="button"
      >
        Private
      </button>
      <button
        className={`visibility-toggles__button${value === 'public' ? ' visibility-toggles__button--active' : ''}`}
        onClick={() => onChange('public')}
        type="button"
      >
        Public
      </button>
    </div>
  )
}

export default VisibilityToggles
